import Portal from '@material-ui/core/Portal';
import { Container, Spinner } from './fullscreen-loading.styles';
import Fade from '@material-ui/core/Fade';
import { useLockBodyScroll } from 'react-use';
import { Suspense } from 'react';

interface Props {
  isLoading: boolean;
}

const FullscreenLoading: React.FC<Props> = ({ isLoading }) => {
  useLockBodyScroll(isLoading);
  return (
    <Portal>
      <Fade in={isLoading} unmountOnExit mountOnEnter>
        <Container>
          <Spinner role="progressbar" aria-label="Carregando" />
        </Container>
      </Fade>
    </Portal>
  );
};

export default FullscreenLoading;

export const SuspenseFullScreenLoading: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => (
  <Suspense fallback={<FullscreenLoading isLoading />}>{children}</Suspense>
);
